<div
    (click)="addToBreadCrumb(data())" stop-click-bubble
    class="drop-shadow-1"
    [ngClass]="isExpanded() ? 'expanded-card' : 'normal-card'"
    (mouseenter)="onHover('in')"
    (mouseleave)="onHover('out')">
    <div class="padding-1 clip4 primary-gradient-bg-100 rounded-1 h-100">
        <div class="clip4 flip-card-front overflow-hidden rounded-1 h-100">
            <div class="user-card p-2 d-flex flex-column rounded-1 content-card h-100">
                <ng-container *ngTemplateOutlet="tile; context: { $implicit: data() }"></ng-container>
            </div>
        </div>
    </div>
</div>

<ng-template
    #tile
    let-val>
    <presenter
        [key]="'tileTop'"
        [data]="val"></presenter>

    @if (isExpanded()) {
        <presenter
            [key]="'tileBottom'"
            [data]="val"></presenter>
    }
</ng-template>
